import { MessageCircle } from "lucide-react";
import useEnquiryForm from "@/hooks/useEnquiryForm";

const REQS = [
  "Solar Plant I&C",
  "BESS I&C",
  "EPC – Balance of Plant",
  "Electrical Contracting",
  "Earth Work & Piling",
  "Land Liaison",
  "Manpower & Material Supply",
  "Other",
];

function TextField({ id, label, type = "text", value, onChange, required, testId, error }) {
  return (
    <div className="ye-form-group">
      <label className="ye-label" htmlFor={id}>{required ? `${label} *` : label}</label>
      <input id={id} className="ye-input" type={type} value={value} onChange={onChange} required={required} data-testid={testId} />
      {error && <div className="ye-error">{error}</div>}
    </div>
  );
}

function SelectField({ id, label, value, onChange, options, required, testId, error }) {
  return (
    <div className="ye-form-group">
      <label className="ye-label" htmlFor={id}>{required ? `${label} *` : label}</label>
      <select id={id} className="ye-select" value={value} onChange={onChange} required={required} data-testid={testId}>
        <option value="">Select a requirement</option>
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
      {error && <div className="ye-error">{error}</div>}
    </div>
  );
}

function TextAreaField({ id, label, value, onChange, testId }) {
  return (
    <div className="ye-form-group">
      <label className="ye-label" htmlFor={id}>{label}</label>
      <textarea id={id} className="ye-textarea" value={value} onChange={onChange} data-testid={testId} />
    </div>
  );
}

export default function EnquiryForm() {
  const { form, errors, handleChange, handleSubmit } = useEnquiryForm();

  return (
    <form onSubmit={handleSubmit} className="ye-card" style={{ padding: 32 }} data-testid="contact-form" noValidate>
      <h2 className="ye-display ye-h3" style={{ margin: "0 0 18px", fontSize: "1.45rem" }}>Send an Enquiry</h2>

      <TextField id="name" label="Name" required value={form.name} onChange={handleChange("name")} testId="form-name" error={errors.name} />
      <TextField id="company" label="Company" value={form.company} onChange={handleChange("company")} testId="form-company" />
      <TextField id="phone" label="Phone" type="tel" required value={form.phone} onChange={handleChange("phone")} testId="form-phone" error={errors.phone} />
      <TextField id="location" label="Project Location" value={form.location} onChange={handleChange("location")} testId="form-location" />
      <SelectField id="requirement" label="Requirement" required value={form.requirement} onChange={handleChange("requirement")} options={REQS} testId="form-requirement" error={errors.requirement} />
      <TextAreaField id="message" label="Message" value={form.message} onChange={handleChange("message")} testId="form-message" />

      <button type="submit" className="ye-btn ye-btn-primary" style={{ width: "100%" }} data-testid="form-submit">
        <MessageCircle size={16} /> Send via WhatsApp
      </button>
      <p style={{ marginTop: 12, fontSize: 13.5, color: "#5b6577", textAlign: "center" }}>
        Prefer email? Write to <a href="mailto:yadurajenterprises9@gmail.com">yadurajenterprises9@gmail.com</a>
      </p>
    </form>
  );
}
